<template>
  <v-app>     
    <v-layout>
      <Navbar />      
      <v-content>
        <CampProducts />
        <Feature />
        <Footer /> 
      </v-content>
      <RightNavbar />  
    </v-layout>
  </v-app>
</template>

<script>
  import Navbar from '@/components/shop/navbar/Navbar'
  import RightNavbar from '@/components/shop/navbar/RightNavbar'
  import CampProducts from  '@/components/shop/products/CampProducts' 
  import Feature from  '@/components/shop/sections/Feature'  
  import Footer from  '@/components/shop/sections/Footer'  
  import db from '@/firebase/init'
  import moment from 'moment'
  export default {
    name:'Home',
    components:{
      Navbar,RightNavbar,CampProducts,Feature,Footer
    },
    data(){
      return{
      
      }
    },
    created(){

    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shop/pages/CampProducts.vue